export const ADMIN_BASE_PATH = "/admin";
export const STAFF_BASE_PATH = "/staff";
export const BUSINESSMAN_BASE_PATH = "/business-man";

const PORTAL_BASE_PATHS = [ADMIN_BASE_PATH, STAFF_BASE_PATH, BUSINESSMAN_BASE_PATH];
const USER_STORAGE_KEY = "mellbizz_user";

export const getPortalBasePath = (role) => {
  const normalizedRole = typeof role === "string" ? role.trim().toUpperCase() : "";

  if (normalizedRole === "BUSINESSMAN") {
    return BUSINESSMAN_BASE_PATH;
  }
  if (normalizedRole === "STAFF") {
    return STAFF_BASE_PATH;
  }
  return ADMIN_BASE_PATH;
};

export const getUserRoleFromStorage = () => {
  try {
    const storedUser = localStorage.getItem(USER_STORAGE_KEY);
    if (!storedUser) return undefined;
    const parsed = JSON.parse(storedUser);
    return parsed?.role;
  } catch (e) {
    return undefined;
  }
};

export const getDefaultPortalPath = () => getPortalBasePath(getUserRoleFromStorage());

export const resolvePortalPath = (path = "", role) => {
  if (!path) {
    return getPortalBasePath(role);
  }

  let normalized = path.trim();
  const matchedBase = PORTAL_BASE_PATHS.find((base) => normalized.startsWith(base));
  if (matchedBase) {
    normalized = normalized.slice(matchedBase.length) || "/";
  }

  if (!normalized.startsWith("/")) {
    normalized = `/${normalized}`;
  }

  const base = getPortalBasePath(role);
  return `${base}${normalized}`.replace(/\/\/+/g, "/");
};

export const stripPortalBasePath = (pathname = "") => {
  return pathname.replace(/^(\/admin|\/staff|\/business-man)\/?/, "");
};

export const isPortalPath = (pathname = "") => {
  return /^(\/admin|\/staff|\/business-man)(\/|$)/.test(pathname);
};
